import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=298fc3b2&scoped=true&lang=pug&"
import script from "./ModalBase.vue?vue&type=script&lang=ts&"
export * from "./ModalBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298fc3b2",
  null
  
)

export default component.exports